module.exports = __webpack_public_path__ + "static/media/logo_cebfiba_rus_white.d9510467.png";